export const LINE_ART = {
  width: 998.707,
  height: 256.163,
  strokes: [
    "M299.288 10.042H87.9914V29.6567H299.288V10.042Z",
    "M865.671 0.5H299.288V29.657H865.671V0.5Z",
    "M998.207 254.961H971.813V50.8618H289.954V254.961H267.615V50.8618H22.1302V254.961H0.5V29.6567H998.207V254.961Z",
    "M22.1302 254.961L110.302 232.695V78.9585L22.1302 50.8618V254.961Z",
    "M289.953 254.961L309.14 235.876V75.2476L289.884 50.8618L289.953 254.961Z",
    "M971.813 254.961V50.8618H925.148L848.299 75.2476V235.876L971.813 254.961Z",
    "M163.087 78.9585H110.302V232.695H163.087V78.9585Z",
    "M267.615 78.9585H110.302V232.695H267.615V78.9585Z",
    "M163.087 92.2117V232.695H193.709V103.874L163.087 92.2117Z",
    "M267.615 78.9585H247.551V232.695H267.615V78.9585Z",
    "M322.359 75.2478H309.14V235.876H322.359V75.2478Z",
    "M386.617 75.2478H322.359V235.876H386.617V75.2478Z",
    "M572.626 113.947L572.396 75.2478H386.617V122.429H489.135L504.271 113.947H572.626Z",
    "M572.626 75.2478H504.27V235.876H572.626V75.2478Z",
    "M651.922 75.2476H592.798V235.876H651.922V75.2476Z",
    "M779.673 220.502L779.791 75.2476H651.922V113.947H686.488V220.502H779.673Z",
    "M848.299 75.2476H779.673V235.876H848.299V75.2476Z",
    "M779.673 84.2598V235.876",
    "M267.615 103.874H193.709V232.695H267.615V103.874Z",
    "M469.27 133.562H386.617V208.309H469.27V133.562Z",
    "M572.627 113.947V235.876L552.661 216.07L553.605 118.24L531.837 130.497H521.234L504.27 140.048H469.27V133.562L504.27 113.947H572.627Z",
    "M521.234 130.497V216.07H552.661L553.605 118.24L531.837 130.497H521.234Z",
    "M531.837 130.497V216.07",
    "M686.488 113.947H592.797V208.31H686.488V113.947Z",
    "M627.114 125.61H592.798V208.309H627.114V125.61Z",
    "M469.27 208.31H504.27L521.234 216.07",
  ],
  controlPath:
    "M1.3976 2.60217C1.06667 3.20374 1.06667 3.99124 1.06667 5.56624V9.06591C1.06667 10.6409 1.06667 11.4284 1.3976 12.03C1.6887 12.5591 2.15319 12.9894 2.72451 13.259C3.374 13.5655 4.22424 13.5655 5.92472 13.5655H9.7032C11.4037 13.5655 12.2539 13.5655 12.9034 13.259C13.4747 12.9894 13.9392 12.5591 14.2303 12.03C14.5612 11.4284 14.5612 10.6409 14.5612 9.06591V5.56624C14.5612 3.99124 14.5612 3.20374 14.2303 2.60217C13.9392 2.07302 13.4747 1.6428 12.9034 1.37318C12.2539 1.06667 11.4037 1.06667 9.7032 1.06667H5.92472C4.22424 1.06667 3.374 1.06667 2.72451 1.37318C2.15319 1.6428 1.6887 2.07302 1.3976 2.60217Z",
  controls: [
    { x: 137.58, y: 59.73 },
    { x: 620.82, y: 92.81 },
    { x: 364.63, y: 149.67 },
  ],
  lights: [
    {
      clip: { x: 163.087, y: 79.281, width: 104.528, height: 153.413 },
      shapes: [
        {
          d: "M148.814 64.4697L218.314 51.4697L266.314 64.4697L165.814 86.9697L148.814 64.4697Z",
          fill: "#47EEEE",
          blur: 50.0,
        },
        {
          d: "M229.814 64.9697L276.814 45.9697L322.814 64.9697L276.814 198.47L229.814 64.9697Z",
          fill: "#FF8E4D",
          blur: 50.0,
        },
        {
          d: "M271.314 171.47L358.814 143.97L370.314 266.47L206.314 171.47H271.314Z",
          fill: "#FF4DA6",
          blur: 50.0,
        },
      ],
    },
    {
      clip: { x: 386.314, y: 133.97, width: 83.0, height: 74.0 },
      shapes: [
        {
          d: "M357.814 146.97L378.314 107.47L483.314 22.9697L522.814 39.9697L442.814 126.47L357.814 146.97Z",
          fill: "#47EEEE",
          blur: 50.0,
        },
      ],
    },
    {
      clip: { x: 592.798, y: 75.247, width: 186.875, height: 160.628 },
      shapes: [
        {
          d: "M839.314 60.970C839.314 92.450 845.794 124.970 814.314 124.970C782.834 124.970 788.314 126.470 765.314 96.470C789.314 58.970 675.334 2.470 706.814 2.470C738.294 2.470 839.314 29.489 839.314 60.970Z",
          fill: "#F65151",
          blur: 50.0,
        },
        {
          d: "M648.814 80.970L643.314 64.970L735.314 37.970L836.314 74.970L729.814 92.470L648.814 80.970Z",
          fill: "#FFB732",
          blur: 50.0,
        },
        {
          d: "M577.814 71.970L626.314 27.970L697.314 49.970L626.314 80.470L568.814 112.470L577.814 71.970Z",
          fill: "#47EEEE",
          blur: 50.0,
        },
      ],
    },
  ],
};
